import { render, staticRenderFns } from "./ShopOrdersTab.vue?vue&type=template&id=39744a30&scoped=true&"
import script from "./ShopOrdersTab.vue?vue&type=script&lang=js&"
export * from "./ShopOrdersTab.vue?vue&type=script&lang=js&"
import style0 from "./ShopOrdersTab.vue?vue&type=style&index=0&id=39744a30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39744a30",
  null
  
)

export default component.exports